export default __webpack_public_path__ + "static/media/cultivos.b21f25ce.png";